import React, { useContext, Suspense } from 'react';
import { ChatIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';

import {
  useDisclosure,
  Drawer,
  DrawerContent,
  DrawerBody,
} from '@chakra-ui/react';
const LazyMartin = React.lazy(() => import('./martin'));
import { AuthContext, Role } from '../../context/AuthProvider';
import { useLocation } from 'react-router-dom';

const MartinChat = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const user = useContext(AuthContext);
  const location = useLocation();

  const isAvailable =
    user != null &&
    user.is_authenticated === true &&
    (user.roles.includes(Role.staff) ||
      ((user.flags.includes('martin-chat') ||
        user.namespaces.includes('tennessee') ||
        user.namespaces.includes('qatar')) &&
        !user.flags.includes('no-martin-chat')));

  if (!location.pathname.includes('/program')) {
    return null;
  }

  if (!isAvailable) {
    return null;
  }

  return (
    <>
      {!isOpen && (
        <IconButton
          isRound={true}
          variant="solid"
          colorScheme="blue"
          aria-label="Martin Chat"
          fontSize="20px"
          size="lg"
          icon={<ChatIcon />}
          position="fixed"
          left="20px"
          bottom="40px"
          onClick={onOpen}
          zIndex={1000}
        />
      )}
      <Drawer isOpen={isOpen} size="lg" placement="left" onClose={onClose}>
        <DrawerContent>
          <DrawerBody w="100vw" padding="0px">
            <Suspense fallback={<div>Loading...</div>}>
              <LazyMartin />
            </Suspense>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};

export default MartinChat;
